export default __webpack_public_path__ + "static/regionalplanning-f725b9de8756ec50465d5353b7105da5.png";